import PropTypes from 'prop-types';
import {SunIcon, MinimalIcon, MoonIcon, GitHubIcon} from './icons';

export default function Header({theme, onToggleTheme, onLogout, username, onDeleteAccount}) {
    const nextIcon = theme === 'dark' ? <SunIcon/> : theme === 'light' ? <MinimalIcon/> : theme === 'minimal' ? <GitHubIcon/> : <MoonIcon/>;
    return (
        <div className="app-header">
            <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
                {nextIcon}
            </button>
            <div className="app-header-right">
                {onLogout && username ? (
                    <span className="username-display">{username}</span>
                ) : null}
                {onDeleteAccount ? (
                    <button className="delete-account-button" onClick={onDeleteAccount}>Delete account</button>
                ) : null}
                {onLogout ? (
                    <button className="sign-out-button" onClick={onLogout}>Sign out</button>
                ) : null}
            </div>
        </div>
    );
}

Header.propTypes = {
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
    onLogout: PropTypes.func,
    username: PropTypes.string,
    onDeleteAccount: PropTypes.func,
};
